module.exports = __webpack_public_path__ + "media/images/category_icons/category_icon_7-9e795bc4bd34a389b9a1c2ca094e9a84.svg";